import React, { FC, ReactNode } from 'react';
import { useDivisionSwitch } from 'src/providers/DivisionSwitchProvider';
import DivisionSwitchingScreen from 'src/components/common/Loading/DivisionSwitchingScreen';

interface MainContentAreaProps {
  children: ReactNode;
}

/**
 * Wraps a layout's main content slot. While a division switch is in flight,
 * renders the switching screen instead of the children so the header / nav
 * stay mounted but the stale-division content is hidden.
 */
const MainContentArea: FC<MainContentAreaProps> = ({ children }) => {
  const { switching, divisionName } = useDivisionSwitch();
  if (switching) {
    return <DivisionSwitchingScreen divisionName={divisionName} />;
  }
  return <>{children}</>;
};

export default MainContentArea;
